// @flow
import styled from "styled-components";

export const ModalInner = styled.div``;

export default ModalInner;